import { render, staticRenderFns } from "./choosePic.vue?vue&type=template&id=4935a09c&scoped=true&"
import script from "./choosePic.vue?vue&type=script&lang=js&"
export * from "./choosePic.vue?vue&type=script&lang=js&"
import style0 from "./choosePic.vue?vue&type=style&index=0&id=4935a09c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4935a09c",
  null
  
)

component.options.__file = "choosePic.vue"
export default component.exports